module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Call#1-0c359d960e5ba518d8157d891fc67337.svg";